import { CONTRACT_PAGE_LOAD, CONTRACT_PAGE_LOAD_SUCCESS, CONTRACT_PAGE_LOAD_FAIL, SET_PAGE_FLAG } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
  showThankyouPopUp: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONTRACT_PAGE_LOAD:
      return {
        ...state,
        loading: true,
      };
    case CONTRACT_PAGE_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case CONTRACT_PAGE_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SET_PAGE_FLAG:
      return {
        ...state,
        showThankyouPopUp: action.data,
      };
    default:
      return state;
  }
}
